// src/Pages/Onboarding/ZidOnboarding/CompletionOnboarding.jsx
import React, { useEffect, useState } from 'react'
import Confetti from 'react-confetti'
import { Button, Spin } from 'antd'
import { useTranslation } from 'react-i18next'
import config from '../../../../config'

export default function CompletionOnboarding({ onComplete, payload }) {
  const { t } = useTranslation()
  const [status, setStatus] = useState('loading') // 'loading' | 'success' | 'error'
  const [runConfetti, setRunConfetti] = useState(false)

  const createAccount = async () => {
    setStatus('loading')

    try {
      const formData = new FormData()
      Object.entries(payload).forEach(([key, value]) => {
        formData.append(key, value)
      })

      const res = await fetch(`${config.baseUrl}/api/user/signup`, {
        method: 'POST',
        body: formData
      })
      if (!res.ok) throw new Error(`Signup failed: ${res.status}`)

      const data = await res.json()
      const { token, trial_days } = data
      if (!token) throw new Error('No token in response')

      localStorage.setItem('token', token)
      console.log(t('zidOnboarding.completionOnboarding.trialDaysLog', { trial_days }))

      setStatus('success')
      setRunConfetti(true)

      setTimeout(() => {
        setRunConfetti(false)
        onComplete()
      }, 4000)
    } catch (err) {
      console.error('Account creation error:', err)
      setStatus('error')
    }
  }

  useEffect(() => {
    createAccount()
  }, [])

  return (
    <div className="relative flex items-center justify-center min-h-screen p-4">
      {status === 'loading' && (
        <div className="text-center">
          <Spin size="large" style={{ color: '#7F28F8' }} />
          <p className="mt-4 text-lg text-gray-700">
            {t('zidOnboarding.completionOnboarding.creatingAccount')}
          </p>
        </div>
      )}

      {status === 'success' && (
        <>
          {runConfetti && (
            <Confetti recycle={false} numberOfPieces={300} gravity={0.2} />
          )}
          <div className="text-center px-4">
            <h1 className="text-4xl font-bold text-purple-700 mb-2">
              🎉 {t('zidOnboarding.completionOnboarding.congrats')} 🎉
            </h1>
            <p className="text-lg text-gray-800 mb-4">
              {t('zidOnboarding.completionOnboarding.successMessage')}
            </p>
          </div>
        </>
      )}

      {status === 'error' && (
        <div className="text-center px-4">
          <h1 className="text-3xl font-semibold text-red-600 mb-2">
            ❌ {t('zidOnboarding.completionOnboarding.errorTitle')}
          </h1>
          <p className="text-gray-700 mb-4">
            {t('zidOnboarding.completionOnboarding.errorMessage')}
          </p>
          <Button
            type="primary"
            onClick={createAccount}
            style={{ backgroundColor: '#7F28F8', borderColor: '#7F28F8' }}
          >
            {t('zidOnboarding.completionOnboarding.retry')}
          </Button>
        </div>
      )}
    </div>
  )
}
